/*
 * Appstle overrides window.fetch and rewrites `selling_plan` on every /cart/add request using
 * `.appstle_sub_widget input[name=selling_plan]:checked`. The theme uses its own subscribe buttons
 * instead of Appstle's widget, so that lookup finds nothing and subscriptions get added as one-time.
 *
 * This keeps a hidden Appstle widget input in sync with whichever add-to-cart form the shopper is
 * using, so Appstle writes back the same plan the form already holds.
 */
(function () {
  if (window.__appstlePlanSync) return;
  window.__appstlePlanSync = true;

  let mirror;

  function getMirror() {
    if (mirror && document.body.contains(mirror)) return mirror;
    const wrapper = document.createElement('div');
    wrapper.className = 'appstle_sub_widget';
    wrapper.hidden = true;
    wrapper.setAttribute('aria-hidden', 'true');
    mirror = document.createElement('input');
    mirror.type = 'radio';
    mirror.name = 'selling_plan';
    mirror.tabIndex = -1;
    wrapper.appendChild(mirror);
    document.body.appendChild(wrapper);
    return mirror;
  }

  function syncFromForm(form) {
    if (!form || !form.querySelector('input[name="id"]')) return;
    const planInput = form.querySelector('[name="selling_plan"]:not([disabled])');
    const planId = planInput ? String(planInput.value || '').trim() : '';
    const input = getMirror();
    input.value = planId;
    input.checked = planId !== '';
  }

  function formFor(target) {
    if (!(target instanceof Element)) return null;
    const control = target.closest('button, input, label');
    return (control && control.form) || target.closest('form');
  }

  // Capture phase runs before any section/product-form handler builds the request.
  document.addEventListener('submit', (event) => syncFromForm(event.target), true);
  document.addEventListener('click', (event) => syncFromForm(formFor(event.target)), true);
})();
